import { Flex } from 'antd';
import FormItem from 'antd/es/form/FormItem';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import stylingGuidePdf from 'src/assets/Wicket_Sites_Styling_Guide_04_2025.pdf';
import { TabPageContentWrapper } from 'src/components/SharedDetailsComponents';
import SettingCard from 'src/pages/Devices/DeviceDetails/TabPages/SensorSettings/components/SettingCard';

import { useSiteDetails } from '../../SiteDetailsContext';
import { HeaderWrapper } from '../Design/Design.styled';
import { GuideIcon, GuideText, StylesheetTextArea } from './Stylesheet.styled';

export const Stylesheet = () => {
  const { formMethods } = useSiteDetails();
  const { t } = useTranslation();

  const openStylingGuide = () => window.open(stylingGuidePdf, '_blank');

  return (
    <>
      <Flex vertical data-testid="stylesheet-flex-container">
        <SettingCard
          title={t('site.stylesheet.cardTitle')}
          description={t('site.stylesheet.description')}
          items={[
            {
              header: (
                <HeaderWrapper onClick={openStylingGuide} data-testid="stylesheet-header">
                  {t('site.stylesheet.stylesheet')}
                  <GuideText data-testid="stylesheet-guide-text">
                    {t('site.stylesheet.stylesheetGuide')} <GuideIcon data-testid="stylesheet-guide-icon" />
                  </GuideText>
                </HeaderWrapper>
              ),
              content: (
                <TabPageContentWrapper $isDesktop={false} data-testid="custom-css-content">
                  <FormItem
                    label={t('site.stylesheet.customSiteCss')}
                    name="design.styleSheet"
                    data-testid="custom-css-form-item"
                  >
                    <Controller
                      name="design.styleSheet"
                      control={formMethods.control}
                      render={({ field }) => (
                        <StylesheetTextArea
                          {...field}
                          placeholder={t('site.stylesheet.customSiteCssPlaceholder')}
                          data-testid="custom-site-css-textarea"
                        />
                      )}
                    />
                  </FormItem>
                </TabPageContentWrapper>
              ),
            },
          ]}
        />
      </Flex>
    </>
  );
};
